import React from 'react';
import DialogMessage from '../../Dialog';
import { renderToString } from 'react-dom/server'
import { prettyDate } from '../../../utils/date';

import { isEmpty } from "lodash"
import useStyles from "./styles";

const ModalDeleteRefuse = ({data, ...props}) => {

   const classes = useStyles();
   const activeSchedulingsStructure = (data) => {
      return (
          <div style={{ minWidth: '500px', display: 'block'}}>
              <strong  className={classes.message}>
              {data?.message}
              </strong>
              <hr />
              {data && !isEmpty(data.data.schedulings) && (
              <div>
                 <strong style={{fontSize: '1.3em', textAlign: 'center', width: '100%', display: 'block'}} className={classes.titleBlock}>
                    AGENDAMENTOS
                 </strong>
                 
                 <table style={{width: '100%'}}
                  data-cy="table-refuse"
                  id="table-refuse"
                 >
                  <thead>
                      <tr>
                          <th style={{ textAlign: 'left' }}>ID</th>
                          <th style={{ textAlign: 'left' }}>Data</th>
                          <th style={{ textAlign: 'left' }}>Placa</th>
                          <th style={{ textAlign: 'left' }}>Motorista</th>
                      </tr>
                  </thead>
                  <tbody>
                      {data && data.data.schedulings.map((d, index) => (
                          <tr key={index}>
                              <td style={{ textAlign: 'left' }}>{d.id}</td>
                              <td style={{textAlign: 'left'}}>{prettyDate(d.scheduling_date)}</td>
                              <td style={{ textAlign: 'left' }}>{d.truck_plate}</td>
                              <td style={{textAlign: 'left'}}>{d.driver_name}</td>
                          </tr>
                      ))}
                  </tbody>
                 </table>
                 <hr />
              </div>
              
              )}
              
              {data && !isEmpty(data.data.plant_quotas) && (
              <div style={{marginTop: '40px'}}>
              <strong className={classes.titleBlock}>
                 COTAS POR PLANTAS
              </strong>
              <table style={{width: '100%'}}
               data-cy="table-plant-quotas"
               id="table-plant-quotas"
              >
               <thead>
                   <tr>
                       <th style={{ textAlign: 'left' }}>Data inicial</th>
                       <th style={{ textAlign: 'left' }}>Data final</th>
                       <th style={{ textAlign: 'left' }}>Turno</th>
                       <th style={{ textAlign: 'left' }}>Planta</th>
                   </tr>
               </thead>
               <tbody>
                  {data && data.data.plant_quotas.map((d, index) => (
                     <tr key={index}>
                        <td style={{ textAlign: 'left' }}>{prettyDate(d.starts_date)}</td>
                        <td style={{textAlign: 'left'}}>{!!d.ends_date ? prettyDate(d.ends_date): 'Em diante'}</td>
                        <td style={{ textAlign: 'left' }}>{d.time_block_description}</td>
                        <td style={{ textAlign: 'left' }}>{d.plant_name}</td>
                     </tr>
                 ))}
               </tbody>
              </table>
              <hr />
           </div>
              )}
   
              {data && !isEmpty(data.data.client_quotas) && (
              <div style={{marginTop: '40px'}}>
              <strong className={classes.titleBlock}>
                 COTAS POR CLIENTE
              </strong>
              <table style={{width: '100%'}}
               data-cy="table-client-quotas"
               id="table-client-quotas"
              >
               <thead>
                   <tr>
                       <th style={{ textAlign: 'left' }}>Data</th>
                       <th style={{ textAlign: 'left' }}>Cotas</th>
                   </tr>
               </thead>
               <tbody>
                 {data && data.data.client_quotas.map((d, index) => (
                    <tr key={index}>
                          <td style={{ textAlign: 'left' }}>{prettyDate(d.date)}</td>
                          <td style={{textAlign: 'left'}}>{d.quantity}</td>
                    </tr>
                 ))}
               </tbody>
              </table>
              <hr />
           </div>
              )}
          </div>
      )
   };
   const {isOpen, closeReadingNotificationDialog} = props;
   const table = renderToString(activeSchedulingsStructure(data));
 
   return <DialogMessage
         isOpen={isOpen}
         data-cy="turn-feedback"
         id="turn-feedback"
         closeReadingNotificationDialog={closeReadingNotificationDialog}
         message={table}
   >
   </DialogMessage>
}

export default ModalDeleteRefuse;
